import ESTIMATE_CONSTANT from "../../constant/estimateConstant"
import type EstimateValues from "../../types/params"
import getConstantByValue from "../constant/getConstantByValue"
import getNumberOfLayers from "../getNumberOfLayers"

const resolveCoverLaySideName = (value: string, { layer }: Pick<EstimateValues, "layer">) => {
  const numberOfLayers = getNumberOfLayers({ layer })
  const isOneLayer = numberOfLayers === 1

  switch (value) {
    case ESTIMATE_CONSTANT.貼る面["パターン面と同じ面を貼る(L1面を貼る)"].value:
      return isOneLayer ? "パターン面と同じ面を貼る" : "L1面を貼る"
    case ESTIMATE_CONSTANT.貼る面["パターン面とは逆の面を貼る(Ln面を貼る)"].value:
      return isOneLayer ? "パターン面とは逆の面を貼る" : `L${numberOfLayers}面を貼る`
    default:
      return getConstantByValue("coverLaySide", value).name
  }
}

export default resolveCoverLaySideName
